import { DomainError } from '../errors/domain-error';

export const COMMUNITY_AFFILIATE_CODE_MAX = 32;
export const COMMUNITY_AFFILIATE_NAME_MAX = 80;
export const COMMUNITY_AFFILIATE_COMMISSION_BPS_MAX = 5000;
export const COMMUNITY_AFFILIATE_COMMISSION_BPS_MIN = 0;
export const COMMUNITY_TRENDING_LIMIT_MAX = 30;

const AFFILIATE_CODE_PATTERN = /^[a-z0-9][a-z0-9_-]{1,31}$/;

export function normalizeCommunityGrowthCode(value: string | null | undefined): string | null {
  const trimmed = value?.trim().toLowerCase();
  return trimmed ? trimmed : null;
}

export function assertCommunityAffiliateCode(code: string): void {
  const normalized = normalizeCommunityGrowthCode(code);
  if (!normalized || !AFFILIATE_CODE_PATTERN.test(normalized)) {
    throw new DomainError(
      'Affiliate code must be 2-32 characters using lowercase letters, numbers, hyphens, or underscores',
    );
  }
}

export function assertCommunityAffiliateCommissionBps(commissionBps: number): void {
  if (
    !Number.isInteger(commissionBps) ||
    commissionBps < COMMUNITY_AFFILIATE_COMMISSION_BPS_MIN ||
    commissionBps > COMMUNITY_AFFILIATE_COMMISSION_BPS_MAX
  ) {
    throw new DomainError('Affiliate commission must be between 0% and 50%');
  }
}

export function canApplyCommunityReferral(params: {
  referralsEnabled: boolean;
  referrerUserId: string;
  joinerUserId: string;
}): boolean {
  if (!params.referralsEnabled) return false;
  if (params.referrerUserId === params.joinerUserId) return false;
  return true;
}
